<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="姓名" prop="nickname">
        <el-input
            v-model="queryParams.cpName"
            placeholder="请输入姓名"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="企微备注" prop="employeeRemark">
        <el-input
            v-model="queryParams.employeeRemark"
            placeholder="请输入备注"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="身份证号" prop="idNumber">
        <el-input
            v-model="queryParams.idNumber"
            placeholder="请输入身份证号"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="phoneNumber">
        <el-input
            v-model="queryParams.phoneNumber"
            placeholder="请输入手机号"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="跟进人" prop="employeeUserId">
        <el-input
            v-model="queryParams.employeeUserId"
            placeholder="请输入跟进人id"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="手术方式" prop="status">
        <el-select
            v-model="queryParams.operationType"
            placeholder="手术方式"
            clearable
            size="small">
          <el-option
              v-for="dict in dict.type.user_operation_type"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"/>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="出院日期" prop="operationDate">-->
<!--        <el-date-picker clearable-->
<!--                        v-model="queryParams.operationDate"-->
<!--                        type="date"-->
<!--                        value-format="yyyy-MM-dd"-->
<!--                        placeholder="请选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
      <el-form-item label="出院日期">
        <el-date-picker
            v-model="dateRange"
            size="small"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
<!--      <el-form-item label="是否官方" prop="officer">-->
<!--        <el-input-->
<!--            v-model="queryParams.officer"-->
<!--            placeholder="请输入是否官方"-->
<!--            clearable-->
<!--            @keyup.enter.native="handleQuery"-->
<!--        />-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          :disabled="single"
          icon="el-icon-plus"
          size="mini"
          @click="refreshUserAllHisRequest"
          v-hasPermi="['biz:User:edit']"
        >同步院内报告</el-button>
      </el-col>
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--            type="primary"-->
<!--            plain-->
<!--            icon="el-icon-plus"-->
<!--            size="mini"-->
<!--            @click="handleUpdate"-->
<!--            v-hasPermi="['biz:user:edit']"-->
<!--        >禁用</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">
        <el-button
            type="danger"
            plain
            icon="el-icon-bell"
            size="mini"
            :disabled="single"
            @click="lookUserSurvey"
            v-hasPermi="['biz:user:edit']"
        >用户信息登记表</el-button>
      </el-col>-->

      <el-col :span="1.5">
        <el-button
            type="warning"
            plain
            icon="el-icon-download"
            size="mini"
            @click="handleExport"
            v-hasPermi="['biz:User:export']"
        >导出
        </el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" align="center"/>
      <el-table-column label="用户id" align="center" prop="id" width="80">
        <template slot-scope="scope">
          <span @click="lookUserProfile(scope.row)"  style="color: #13ce66">{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column label="跟进人" align="center" prop="employeeUserId" width="80" />
      <el-table-column label="备注" align="center" prop="employeeRemark" width="150" />

      <el-table-column label="企微姓名/昵称" align="center" prop="cpName" >
        <template slot-scope="scope">
          <span v-if="scope.row.cpName === scope.row.nickname">{{scope.row.cpName}}</span>
          <span v-else>{{scope.row.cpName}}/{{scope.row.nickname}}</span>
        </template>
      </el-table-column>
      <el-table-column label="头像" align="center" prop="cpAvatar">
        <template slot-scope="scope">
          <img style="width: 50px;height: 50px" :src="scope.row.cpAvatar">
        </template>
      </el-table-column>
      <el-table-column label="手机号(登记表)" align="center" prop="phoneNumber">
        <template slot-scope="scope">
          <span class="click-btn" @click="lookUserSurvey(scope.row)">{{scope.row.phoneNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" align="center" prop="idNumber">
        <template slot-scope="scope">
          <span class="click-btn" @click="handleOperation(scope.row)">{{scope.row.idNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户状态" align="center" prop="status" width="80">
        <template slot-scope="scope">
          {{ getSelectNameByEnumsAndValue(userStatusList, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
              v-hasPermi="['biz:User:edit']"
          >修改</el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="lookUserProfile(scope.row)"
              v-hasPermi="['biz:User:edit']"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
    />

    <!-- 添加或修改客户对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="小程序姓名" prop="nickname">
              <span slot="label">
                <el-tooltip content="客户在小程序中填写的姓名，会在挂号订单中默认使用该名称，修改后仅在小程序中生效" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                小程序姓名</span>
              <el-input v-model="form.nickname" placeholder="请输入姓名"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企微姓名" prop="cpName">
              <span slot="label">
                <el-tooltip content="默认来自微信昵称，填写个人信息登记表后会同步更新该字段，后台展示客户使用该字段" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                企微姓名</span>
              <el-input v-model="form.cpName" placeholder="请输入姓名"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phoneNumber">
              <span slot="label">
                <el-tooltip content="该字段来源于个人信息登记表，没有验证是否是本人，并且该字段会接收到短信通知，同步展示在小程序端" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                手机号</span>
              <el-input v-model="form.phoneNumber" placeholder="请输入手机号"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNumber">
              <span slot="label">
                <el-tooltip content="该字段用来同步院内检查报告，确定用户性别，和小程序端同步展示" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                身份证号</span>
              <el-input v-model="form.idNumber" placeholder="身份证号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="病案号" prop="admissionNumber">
              <span slot="label">
                <el-tooltip content="该字段仅做展示，小程序端会同步展示，客户不可修改" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                病案号</span>
              <el-input v-model="form.admissionNumber" placeholder="病案号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手术方式" prop="operationType">
              <span slot="label">
                <el-tooltip content="该字段可以新增在字典配置表中维护" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                手术方式</span>
              <el-select v-model="form.operationType" placeholder="请选择">
                <el-option
                v-for="dict in dict.type.user_operation_type"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出院时间" prop="operationDate">
              <span slot="label">
                <el-tooltip content="填写后，会纳入出院人数，并且默认作为标准路径的出院时间" placement="top">
                <i class="el-icon-question"></i>
                </el-tooltip>
                出院时间</span>
              <el-date-picker
                  style="width: 100%"
                  v-model="form.operationDate"
                  clearable
                  placeholder="出院时间"
                  type="date"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="婚姻状态" prop="maritalStatus">
              <el-select v-model="form.maritalStatus" placeholder="请选择">
                <el-option
                    v-for="item in maritalStatusList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医保类型" prop="medicalType">
              <el-select v-model="form.medicalType" placeholder="请选择">
                <el-option
                    v-for="item in medicalTypeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="居住地" prop="residence">
              <el-input v-model="form.residence" placeholder="居住地"/>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>


    <!-- 添加或修改客户对话框 -->
    <el-dialog :title="titleOperation" :visible.sync="openOperation" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input v-model="form.idNumber" placeholder="身份证号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="病案号" prop="admissionNumber">
              <el-input v-model="form.admissionNumber" placeholder="病案号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="婚姻状态" prop="maritalStatus">
              <el-select v-model="form.maritalStatus" placeholder="请选择">
                <el-option
                    v-for="item in maritalStatusList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医保类型" prop="medicalType">
              <el-select v-model="form.medicalType" placeholder="请选择">
                <el-option
                    v-for="item in medicalTypeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手术方式" prop="operationType">
              <el-select v-model="form.operationType" placeholder="请选择">
                <el-option
                    v-for="dict in dict.type.user_operation_type"
                    :key="dict.value"
                    :label="dict.label"
                    :value="dict.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出院时间" prop="operationDate">
              <el-date-picker
                  style="width: 100%"
                  v-model="form.operationDate"
                  clearable
                  placeholder="出院时间"
                  type="date"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="居住地" prop="residence">
              <el-input v-model="form.residence" placeholder="居住地"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormOperation">确 定</el-button>
        <el-button @click="cancelOperation">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加或修改客户对话框 -->
    <el-drawer :title="titleUserIndex" :visible.sync="openUserIndex" direction="rtl" size="80%">
        <el-row :gutter="20" style="height: calc(100vh - 70px);">
          <el-col :span="6" :xs="24" style="height: calc(100vh - 70px);">
            <el-card class="box-card" style="height: 100%">
              <div slot="header" class="clearfix">
                <span>患者信息</span>
              </div>
              <div>
                <div class="text-center">
                  <img style="width: 50px;height: 50px" :src="currentUser.cpAvatar">
                </div>
                <ul class="list-group list-group-striped">
                  <li class="list-group-item">
                    <svg-icon icon-class="user" />患者姓名
                    <div class="pull-right">{{currentUser.cpName}}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="user" />患者来源
                    <div class="pull-right" v-if="currentUser.unionId">微信客户</div>
                    <div class="pull-right" v-else>企业微信客户</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />身份证号
                    <div class="pull-right">{{currentUser.idNumber}}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />手机号码
                    <div class="pull-right">{{currentUser.phoneNumber}}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />病案号
                    <div class="pull-right">{{currentUser.admissionNumber}}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />手术方式
                    <div class="pull-right" v-if="currentUser.operationType">{{dict.type.user_operation_type.filter(item => item.value === currentUser.operationType)[0].label}}</div>
                    <div class="pull-right" v-else>未填写</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />出院时间
                    <div class="pull-right">{{currentUser.operationDate}}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />婚姻状况
                    <div class="pull-right">{{ getSelectNameByEnumsAndValue(maritalStatusList,currentUser.maritalStatus) }}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />居住地
                    <div class="pull-right">{{currentUser.residence}}</div>
                  </li>
                  <li class="list-group-item">
                    <svg-icon icon-class="phone" />医保类型
                    <div class="pull-right">{{ getSelectNameByEnumsAndValue(medicalTypeList, currentUser.medicalType) }}</div>
                  </li>
                </ul>
              </div>
            </el-card>
          </el-col>
          <el-col :span="18" :xs="24" v-if="show">
            <el-card style="height: 100%;">
              <el-tabs v-model="activeTab">
                <el-tab-pane label="检查报告" name="userReport">
                  <userReport v-if="activeTab === 'userReport'" :user="currentUser"/>
                </el-tab-pane>
                <el-tab-pane label="标准路径" name="userTemplate">
                  <userStandardTemplate v-if="activeTab === 'userTemplate'" :user="currentUser"/>
                </el-tab-pane>
                <el-tab-pane label="挂号订单" name="userChannelOrderList">
                  <userChannelOrderList v-if="activeTab === 'userChannelOrderList'" :user="currentUser"/>
                </el-tab-pane>
                <el-tab-pane label="体重数据" name="userWeightList">
                  <userWeightList v-if="activeTab === 'userWeightList'"  :user="currentUser"/>
                </el-tab-pane>
                <el-tab-pane label="血糖数据" name="userSugarBloodList">
                  <userSugarBloodList v-if="activeTab === 'userSugarBloodList'"  :user="currentUser"/>
                </el-tab-pane>
                <el-tab-pane label="体型变化" name="userBodyPhotoList">
                  <userBodyPhotoList v-if="activeTab === 'userBodyPhotoList'"  :user="currentUser"/>
                </el-tab-pane>
                <el-tab-pane label="备忘录" name="userNoteList">
                  <userNoteList v-if="activeTab === 'userNoteList'"  :user="currentUser"/>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </el-col>
        </el-row>
    </el-drawer>
    <!-- 个人问卷登记表 -->
    <el-drawer
      title="个人信息登记表"
      :visible.sync="openSurvey"
      direction="rtl"
      size="30%">
<!--      <div class="title">基础信息</div>-->
      <div
        v-for="(formItem, index) in surveyDetailUserList"
        :class="formItem.channel === 2 ? 'component-item block' : 'component-item inline'"
        :key="formItem.id"
      >
        <div :class="formItem.required ? 'component-item-label required' : 'component-item-label'">{{formItem.questNo}}、{{formItem.question}}</div>
        <div class="component-item-desc" v-if="formItem.answer && formItem.answer.indexOf('bmi') > -1">
          <div class="bmi-item">
            <label>您的身高</label>
            <div>{{ formItem.answer && JSON.parse(formItem.answer).height || '-' }}</div>
            <label>cm</label>
          </div>
          <div class="bmi-item">
            <label>您的体重</label>
            <div>{{ formItem.answer && JSON.parse(formItem.answer).weight || '-' }}</div>
            <label>kg</label>
          </div>
          <div style="margin-top: 10px;">
            <label style="margin-right: 10px;">您的BMI指数:</label>
            <spa>{{ formItem.answer && JSON.parse(formItem.answer).bmi || '-' }}</spa>
          </div>
        </div>
        <div class="component-item-desc" v-else>{{formItem.answer || '-'}}</div>

      </div>

<!--      <div class="title">手术信息</div>-->
<!--      <div-->
<!--        v-for="(formItem, index) in fields"-->
<!--        class="component-item block"-->
<!--        :key="index"-->
<!--      >-->
<!--        <div class="component-item-label">{{formItem.name}}</div>-->
<!--        <div class="component-item-desc" v-if="formItem.field === 'maritalStatus'">{{ getSelectNameByEnumsAndValue(maritalStatusList || [], form[formItem.field]) }}</div>-->
<!--        <div class="component-item-desc" v-else-if="formItem.field === 'operationType'">{{ getSelectNameByEnumsAndValue(operationTypeList || [], form[formItem.field]) }}</div>-->
<!--        <div class="component-item-desc" v-else-if="formItem.field === 'medicalType'">{{ getSelectNameByEnumsAndValue(medicalTypeList || [], form[formItem.field]) }}</div>-->
<!--        <div class="component-item-desc" v-else>{{ form[formItem.field] }}</div>-->
<!--      </div>-->
    </el-drawer>
  </div>
</template>

<script>
import {addUser, delUser, getUser, listUser, updateUser,refreshUserAllHisRequest} from "@/api/biz/User";
// 读取公共枚举
import {getEnumByClassFullName} from "@/api/biz/common";
import {getUserReportWithTemplate} from "@/api/biz/ReportUserTotal";
import {listSurveyDetailUser} from "@/api/biz/SurveyDetailUser";
import UserReport from "@/views/biz/User/detail/userReport";
import UserStandardTemplate from "@/views/biz/User/detail/userStandardTemplate";
import UserWeightList from "@/views/biz/User/detail/userWeightList";
import UserSugarBloodList from "@/views/biz/User/detail/userSugarBloodList";
import UserNoteList from "@/views/biz/User/detail/userNoteList";
import UserBodyPhotoList from "@/views/biz/User/detail/userBodyPhotoList";
import UserChannelOrderList from "@/views/biz/User/detail/userChannelOrderList";
import { COMPONENTS, DEFAULT_CONPONENTS, CHANNEL_TYPE, COMPONENT_TYPE, COMPONENT_SUB_TYPE, NEED_CONFIG_DATA } from '../../tool/visual-drag/config';


export default {
  name: "User",
  dicts: ['sys_normal_disable', 'user_operation_type'],
  components: {UserWeightList, UserStandardTemplate, UserReport,UserSugarBloodList, UserNoteList, UserBodyPhotoList,UserChannelOrderList},
  data() {
    return {
      components: COMPONENTS,
      COMPONENT_TYPE,
      COMPONENT_SUB_TYPE,
      CHANNEL_TYPE,
      NEED_CONFIG_DATA,
      activeTab: 'userReport',
      genderList: [],
      userStatusList: [],
      userTypeList: [],
      operationTypeList: [],
      medicalTypeList: [],
      maritalStatusList: [],
      // 日期范围
      dateRange: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 
      show: false,
      // 总条数
      total: 0,
      // 客户表格数据
      userList: [],
      // 弹出层标题
      title: "",
      titleUserIndex: "",
      // 是否显示弹出层
      open: false,
      openUserIndex: false,
      openSurvey: false,
      currentUser:{},
      surveyDetailUserList: [],
      baseInfoSurveyIds:[],
      fields: [{
        name: '身份证号',
        field: 'idNumber'
      }, {
        name: '病案号',
        field: 'admissionNumber'
      }, {
        name: '婚姻状态',
        field: 'maritalStatus'
      }, {
        name: '医保类型',
        field: 'medicalType'
      }, {
        name: '手术方式',
        field: 'operationType'
      }, {
        name: '出院时间',
        field: 'operationDate'
      }, {
        name: '居住地',
        field: 'residence'
      }],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        nickname: null,
        cpName: null,
        employeeRemark: null,
        headPic: null,
        gender: null,
        idNumber: null,
        phoneNumber: null,
        admissionNumber: null,
        createDate: null,
        operationDate: null,
        updateDate: null,
        officer: null
      },
      titleReport: "",
      titleOperation: "",
      // 是否显示弹出层
      openReport: false,
      openOperation: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        phoneNumber: [{
          required: false,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1(0|1|2|3|4|5|6|7|8|9)\d{9}$/,
          message: '手机号格式错误',
          trigger: 'blur'
        }],
        idNumber: [{
          required: false,
          message: '请输入身份证号',
          trigger: 'blur'
        }, {
          pattern: /^(^\d{15}$|^\d{18}$|^\d{17}(\d|X))$/,
          message: '身份证号格式错误',
          trigger: 'blur'
        }],
      }
    };
  },
  created() {
    this.getUserGenderEnum();
    this.getUserStatusEnum();
    this.getUserTypeEnum();
    this.getUserMaritalStatusEnum();
    this.getUserMedicalTypeEnum();
    this.getList();
  },
  methods: {
    getUserMaritalStatusEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UserMaritalStatusEnum").then(res => {
        this.maritalStatusList = res.data;
      })
    },
    getUserMedicalTypeEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UserMedicalTypeEnum").then(res => {
        this.medicalTypeList = res.data;
      })
    },
    getUserGenderEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UserGenderEnum").then(res => {
        this.genderList = res.data;
      })
    },
    getUserStatusEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UserStatusEnum").then(res => {
        this.userStatusList = res.data;
      })
    },
    getUserTypeEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UserTypeEnum").then(res => {
        this.userTypeList = res.data;
      })
    },

    /** 查询客户列表 */
    getList() {
      this.loading = true;
      console.log(this.dateRange)
      this.queryParams.operationDateStart = this.dateRange[0];
      this.queryParams.operationDateEnd = this.dateRange[1];
      listUser(this.queryParams).then(response => {
        this.userList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 取消按钮
    cancelOperation() {
      this.openOperation = false;
      this.reset();
    },

    // 表单重置
    reset() {

      this.form = {
        id: null,
        nickname: null,
        headPic: null,
        unionId: null,
        gender: null,
        birthday: null,
        idNumber: null,
        phoneNumber: null,
        admissionNumber: null,
        createDate: null,
        updateDate: null,
        officer: null
      };
      this.resetForm("form");
      this.surveyDetailUserList = [];
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
      }
      this.dateRange= [];
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加客户";
    },
    lookUserSurvey(row) {
      this.reset();
      debugger
      let id = row.baseInfoSurveyId
      if (!id) {
        this.$modal.msgError("患者暂未填写个人信息登记表");
        return
      }

      this.openSurvey = true;
      listSurveyDetailUser({userSurveyId: id}).then(response => {
        let _surveyDetailUserList = (response?.rows || []).map(item => {
          item.options = JSON.parse(item.optionsJson || '[]');
          console.log(item.optionsJson, item)

          if(item.options.length > 0) {
            let value = item.answer || item.answers || '';
            item.answer = !value ? value : JSON.parse(value).map(it => {
              return item.options.find(op => `${op.optionNo}` === `${it}`)?.optionTxt || '';
            }).join(',');

          }
          return item;
        })
        console.log(_surveyDetailUserList);
        this.surveyDetailUserList = _surveyDetailUserList;

      })

      this.handleOperation(row, true);
    },
    lookUserProfile(row) {
      this.currentUser = row;
      this.openUserIndex = true;
      this.show = false;
      this.titleUserIndex = '患者主页';

      setTimeout(() => {
        this.show = true;
      }, 10);
    },
    /** 补充手术按钮操作 */
    handleOperation(row, flag) {
      this.reset();
      const id = row.id || this.ids
      getUser(id).then(response => {
        this.form = response.data;
        if(!flag) {
          this.openOperation = true;
        }
        this.titleOperation = this.form.cpName + " 出院信息";
      });
    },
    /** 拉取患者 报告 */
    refreshUserAllHisRequest(row) {
      const id = row.id || this.ids
      this.$modal.confirm('是否确认拉取患者的院内所有报告数据？').then(function () {
        return refreshUserAllHisRequest(id);
      }).then(() => {
        this.$modal.msgSuccess("请求已发送，等待任务执行，预计5分钟内完成");
      }).catch(() => {
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getUser(id).then(response => {
        this.form = response.data;
        this.form.operationType = (this.form.operationType || this.form.operationType === 0) ? `${this.form.operationType}` : this.form.operationType;
        this.open = true;
        this.title = "修改客户";
      });
    },
    /** 提交按钮 */
    submitFormOperation() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateUser(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.openOperation = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateUser(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addUser(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除客户编号为"' + ids + '"的数据项？').then(function () {
        return delUser(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {
      });
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biz/user/export', {
        ...this.queryParams
      }, `user_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
<style>
  .click-btn {
    cursor: pointer;
    color: #1890ff;
  }
  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    color: #1890ff;
    padding: 0 15px;
  }
  .component-item {
    display: flex;
    padding: 15px;
    border-bottom: 1px solid #f2f2f2;
  }

  .component-item.block {
    flex-direction: column;
    justify-content: center;
    align-items: space-between;
  }

  .component-item.block .component-item-desc {
    margin-top: 10px;
  }

  .component-item.inline {
    flex-direction: row;
    justify-content: space-between;
  }

  .component-item-label {
    font-size: 16px;
    color: #000;
  }

  .component-item-label.required {
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: -6px;
      content: '*';
      font-size: 14px;
      color: red;
    }

  }

  .component-item-desc {
    font-size: 16px;
    color: #999;
  }
  .bmi-item {
    display: flex;
    align-items: center;
  }

  .bmi-item div{
    width: 100px;
    padding: 10px 0;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
</style>
